import Crud from '../components/Ingredient/Crud'

let routes = {
    path: '/ingredient',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/ingredient',
            component: Crud
        }
    ]        
}


export default routes


// WEBPACK FOOTER //
// ./src/router/ingredient.js